const rain = ['IMG_0001.JPG',
'IMG_0002.JPG',
'IMG_0011.JPG',
'IMG_0116.JPG',
'IMG_0824.JPG',
'IMG_0834.JPG',
'IMG_0840.JPG',
'IMG_0841.JPG',
'IMG_0853.JPG',
'IMG_0995.JPG',
'IMG_1003.JPG',
'IMG_1051.JPG',
'IMG_1473.JPG',
'IMG_1617.JPG',
'IMG_1813.JPG',
'IMG_2092.JPG',
'IMG_2115.JPG',
'IMG_2503.JPG',
'IMG_2504.JPG',
'IMG_2598.JPG',
'IMG_2646.JPG',
'IMG_2651.JPG',
'IMG_2652.JPG',
'IMG_2658.JPG',
'IMG_2659.JPG',
'IMG_2890.JPG',
'IMG_2894.JPG',
'IMG_2896.JPG',
'IMG_3006.JPG',
'IMG_3008.JPG',
'IMG_3216.JPG',
'IMG_3275.JPG',
'IMG_3289.JPG',
'IMG_3469.JPG',
'IMG_3470.JPG',
'IMG_3594.JPG',
'IMG_3607.JPG',
'IMG_3610.JPG',
'IMG_3611.JPG',
'IMG_3612.JPG',
'IMG_3613.JPG',
'IMG_3614.JPG',
'IMG_3694.JPG',
'IMG_3696.JPG',
'IMG_4223.JPG',
'IMG_4251.JPG',
'IMG_4252.JPG',
'IMG_4263.JPG',
'IMG_4287.JPG',
'IMG_4314.JPG',
'IMG_4315.JPG',
'IMG_4326.JPG',
'IMG_4331.JPG',
'IMG_4394.JPG',
'IMG_4399.JPG',
'IMG_4400.JPG',
'IMG_4518.JPG',
'IMG_4519.JPG',
'REBELXS_IMG_0967.JPG',
'REBELXS_IMG_1118.JPG',
'REBELXS_IMG_1119.JPG',
'REBELXS_IMG_1123.JPG',
'REBELXS_IMG_1132.JPG',
'REBELXS_IMG_2335.JPG',
'REBELXS_IMG_2986.JPG',
'REBELXS_IMG_3010.JPG',
'REBELXS_IMG_3018.JPG',
'REBELXS_IMG_3019.JPG',
'REBELXS_IMG_3021.JPG',
'REBELXS_IMG_3022.JPG',
'REBELXS_IMG_3024.JPG',
'REBELXS_IMG_3026.JPG',
'REBELXS_IMG_3027.JPG',
'REBELXS_IMG_3029.JPG',
'REBELXS_IMG_3033.JPG',
'REBELXS_IMG_3035.JPG',
'REBELXS_IMG_3241.JPG',
'STE_3214.JPG',
'IPHONE2G_IMG_0031.JPG',
'IPHONE2G_IMG_0038.JPG',
'IPHONE2G_IMG_0110.JPG',
'IPHONE2G_IMG_0111.JPG',
'IPHONE2G_IMG_0262.JPG',
'IPHONE2G_IMG_0317.JPG',
'IPHONE2G_IMG_0500.JPG',
'IPHONE2G_IMG_0502.JPG'];

export default rain;